import React from 'react'
import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp'
import Marquee from 'react-fast-marquee'

export default function Properties() {

    const properties = [
        {
            image: 'https://albidayahgroups.com/Media/Properties/3d-rendering-abstract-building.jpg',
            title: 'Innovative Designs',
        },
        {
            image: 'https://albidayahgroups.com/Media/Properties/A%20sustainable%20home%20along%20a%20landscape.jpg',
            title: 'Sustainability',
        },
        {
            image: 'https://albidayahgroups.com/Media/Properties/realestate-timely.jpg',
            title: 'Timely Delivery',
        },
    ];

    const types = [
        {
            title: <>Residential<br />Developments</>,
            image: 'https://albidayahgroups.com/Media/Properties/analog-landscape-city-with-buildings.jpg',
        },
        {
            title: <>Mixed-Use<br />Developments</>,
            image: 'https://albidayahgroups.com/Media/Properties/architectural-assessment-by-real-estate-developer.jpg',
        },
        {
            title: <>Commercial<br />Properties</>,
            image: 'https://albidayahgroups.com/Media/Properties/woman-studying-draft-construction-site.jpg',
        },
        {
            title: <>Real Estate<br />Investment</>,
            image: 'https://albidayahgroups.com/Media/Properties/design-house-modern-villa-with-open-plan-living-private-bedroom-wing-large-terrace-with-privacy.jpg',
        },
    ];

    return (
        <div>
            <div className="relative w-full h-screen">
                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Properties/photorealistic-house-with-wooden-architecture-timber-structure.jpg')` }}
                ></div>

                {/* Milled Dark Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-50 mix-blend-multiply"></div>

                {/* Text Overlay - Left Side */}
                <div className="relative z-10 flex items-center h-full px-6 md:px-16">
                    <div className="text-white">
                        <FadeInSectionDownToUp>
                            <h1 className="text-6xl max-sm:text-4xl font-bold mb-4 leading-tight">
                                Built on <span className='text-[#8FAC40]'>Trust.</span><br />
                                Designed for <span className='text-[#8FAC40]'>Life.</span>
                            </h1>
                            <p className="text-lg md:text-xl max-w-xl">
                                Experience The Best For You.
                            </p>
                        </FadeInSectionDownToUp>
                    </div>
                </div>
            </div>
            <div className="relative w-full h-full py-20 max-sm:py-10">
                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-cover bg-center opacity-20"
                    style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Properties/mumbai-skyline-skyscrapers-construction.jpg')` }}
                ></div>

                {/* Milled Dark Overlay */}
                {/* <div className="absolute inset-0 bg-black bg-opacity-50 mix-blend-multiply"></div> */}

                {/* Text Overlay - Left Side */}
                <div className="relative z-10 h-full px-5 md:px-16">
                    <div className="text-black w-full">
                        <FadeInSectionDownToUp>
                            <p className="text-4xl max-sm:text-4xl font-bold mb-4 leading-tight">
                                About<br /> <span className='text-[#8FAC40] text-6xl max-sm:text-4xl'>AB-Property</span>
                            </p>
                            <div className='bg-[#1E2802] rounded-3xl text-white px-10 py-5'>
                                <p className="text-xl text-justify">
                                    At AL-BIDAYAH, we specialize in crafting premium, sustainable, and innovative real estate developments. With over three
                                    decades of experience across Malaysia, our portfolio includes residential, commercial, and mixed-use spaces each built
                                    to the highest standards of design and quality. Whether you're searching for your dream home or the perfect business
                                    address, we’re here to help you make it happen with expertise you can trust.
                                </p>
                            </div>
                        </FadeInSectionDownToUp>
                    </div>
                </div>
                <div className='relative z-10 px-20 max-sm:px-5 pt-20 max-sm:pt-5 space-y-5'>
                    <div>
                        <FadeInSectionDownToUp>
                            <p className='text-3xl text-[#420110] font-bold'>Why Choose Us?</p>
                        </FadeInSectionDownToUp>
                    </div>
                    <div className="py-8">
                        <Marquee pauseOnHover={true} speed={50} gradient={false}>
                            {properties.map((property, index) => (
                                <div
                                    key={index}
                                    className="relative m-4 min-w-[400px] max-w-sm rounded-2xl overflow-hidden border-2 shadow-lg"
                                >
                                    {/* 📸 Image */}
                                    <img
                                        src={property.image}
                                        alt={property.title}
                                        className="w-full h-64 object-cover"
                                    />

                                    {/* 🧊 Overlay */}
                                    <div className="absolute inset-0 bg-black/30 z-10" />

                                    {/* 📝 Bottom-Left Text */}
                                    <div className="absolute bottom-4 left-4 z-20 text-white">
                                        <p className="text-2xl font-bold">{property.title}</p>
                                    </div>

                                    {/* 🌀 Decorative Clip-Circle */}
                                    <div className="absolute bottom-0 left-0 w-20 h-20 bg-blue-400 z-0 clip-circle rounded-bl-2xl" />
                                </div>
                            ))}
                        </Marquee>
                    </div>
                    <div>
                        <p className="text-2xl text-justify">
                            We adopt a customer-centric approach, offering tailored solutions that address the unique needs
                            of each project. From residential homes to commercial developments, we ensure that each space
                            enhances the quality of life for those who use it.
                        </p>
                    </div>
                </div>
                <div className='relative w-full h-full px-20 max-sm:px-5 py-20 max-sm:py-10'>
                    <div className="max-w-7xl mx-auto px-4 py-10">
                        <FadeInSectionDownToUp>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                            {types.map((property, index) => (
                                <div key={index} className="flex flex-col items-start">
                                    {/* 🖼️ Image */}
                                    <img
                                        src={property.image}
                                        alt={property.title}
                                        className="w-full h-[600px] object-cover rounded-xl shadow-md"
                                    />
                                    {/* 📝 Text */}
                                    <p className="mt-4 text-2xl font-bold text-gray-800">{property.title}</p>
                                </div>
                            ))}
                        </div>
                        </FadeInSectionDownToUp>
                    </div>
                </div>
            </div>
        </div>
    )
}
